import renderDateTime from "utils/renderDateTime";

import { EventHeadingProps } from "./types";
import * as Styled from "./styles";

const EventHeading: React.FC<EventHeadingProps> = ({
  date,
  event: { name, venue, timezone },
}) => (
  <Styled.Wrapper>
    <Styled.Name>{name}</Styled.Name>
    <Styled.Location>{venue?.name}</Styled.Location>
    <Styled.Date>{renderDateTime(date, timezone)}</Styled.Date>
  </Styled.Wrapper>
);

export default EventHeading;
